/* Publish by EComposer at 2025-08-04 04:42:59*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-05qd3jw3i7eh"]=  window.__ectimmers["ecom-05qd3jw3i7eh"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(t&&t.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",t.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-05qd3jw3i7eh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-05qd3jw3i7eh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4bixbdpwi3y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4bixbdpwi3y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7olctk9lds').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7olctk9lds', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0sh6cno7anc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0sh6cno7anc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c03ix1zjv8q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c03ix1zjv8q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pddcr0r2y48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pddcr0r2y48', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nu2lgmkoz9t"]=  window.__ectimmers["ecom-nu2lgmkoz9t"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(i){if(!e)return;const o=e.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-nu2lgmkoz9t"]["2dsd2vblp"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var t=e.querySelector(".ecom__element--button");this.isLive&&t&&t.dataset.ecTrackingId&&t.addEventListener("click",function(i){if(window.Shopify.analytics){i.preventDefault();let o=document.createElement("div");document.body.appendChild(o),o.click();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const s=Object.assign({button_id:t.id,tracking_id:t.dataset.ecTrackingId},n);Shopify.analytics.publish("ec_custom_events",s),t.cloneNode(!0).click()}},{once:!0}),this.isLive&&t&&t.dataset.eventTrackingFb&&t.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${t.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-nu2lgmkoz9t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nu2lgmkoz9t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjzhqkp1zu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjzhqkp1zu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nifduyduidl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nifduyduidl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ivosub1j6t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ivosub1j6t', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-s1308mvwr0q"]=  window.__ectimmers["ecom-s1308mvwr0q"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let t=this.$el;if(!t)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=t.querySelector(".ecom-element.ecom-base-image"),s=t.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-s1308mvwr0q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s1308mvwr0q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-asc0vu4dq0e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-asc0vu4dq0e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2xr1p7ii3pa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2xr1p7ii3pa', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-60fq0l11p3w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-60fq0l11p3w', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ldex2btqp3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ldex2btqp3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d3dfyg9ewnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d3dfyg9ewnl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dftsaf2guk8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dftsaf2guk8', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}